import {FILE_DATA, LOADER_STATUS , SAVE_TOTAL_PAGES} from "./constants";

export const initialState = {
    loaderStatus: false,  
    fileData: [],
    totalPages: 1,
};
  
  /* eslint-disable default-case, no-param-reassign */
  const itc04UploadReducer = (state = initialState, action) =>{
      switch (action.type) {
        
        case LOADER_STATUS:
          return {
            ...state,
            loaderStatus:action.loaderStatus
          }
          case FILE_DATA:
            return {
              ...state,
              fileData:action.fileData
            }
            case SAVE_TOTAL_PAGES:
              return {
                ...state,
                totalPages:action.pages
              }
        default:
          return state;
      }
    };
  
  export default itc04UploadReducer;